var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ordenes---MovilDash",
    transform: "translate(-328.000000, -397.000000)",
    fill: "#585858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(328.000000, 397.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6000977,8.0001317 C1.6000977,4.46549033 4.46549033,1.6000977 8.0001317,1.6000977 C11.5347727,1.6000977 14.4001657,4.46549033 14.4001657,8.0001317 C14.4001657,11.5347727 11.5347727,14.4001657 8.0001317,14.4001657 C4.46549033,14.4001657 1.6000977,11.5347727 1.6000977,8.0001317 Z M8,0 C3.5888264,0 0,3.58874316 0,8 C0,12.4112572 3.5888264,16.000084 8,16.000084 C12.4111728,16.000084 16,12.4112572 16,8 C16,3.5887422 12.411256,0 8,0 L8,0 Z M12.593599,6.6488903 L7.5676059,11.674884 C7.35390116,11.8885885 7.06982349,12.0062099 6.76763095,12.0062099 C6.4654384,12.0062099 6.18136073,11.8885885 5.96765619,11.674884 L3.40611694,9.11334423 C3.19241175,8.89963939 3.074707,8.6155616 3.074707,8.31336904 C3.074707,8.01109295 3.19241175,7.72701532 3.40611694,7.51331047 C3.61973841,7.29960563 3.90381588,7.18190029 4.2060919,7.18190029 C4.5082841,7.18190029 4.7924454,7.29960563 5.00606681,7.51339393 L6.76754752,9.27479142 L10.9934822,5.04885588 C11.2071871,4.83515064 11.4912648,4.7175293 11.7934579,4.7175293 C12.0956499,4.7175293 12.3797276,4.83515064 12.5934335,5.04885588 C13.0346989,5.49012383 13.0346989,6.20778912 12.593599,6.6488903 L12.593599,6.6488903 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9de638a2b7a7153bfd3bfc9f92f6946b.svg";
export { ForwardRef as ReactComponent };